import { render, staticRenderFns } from "./infoAdvertisingSpace.vue?vue&type=template&id=0cef1a33&scoped=true"
import script from "./infoAdvertisingSpace.vue?vue&type=script&lang=js"
export * from "./infoAdvertisingSpace.vue?vue&type=script&lang=js"
import style0 from "./infoAdvertisingSpace.vue?vue&type=style&index=0&id=0cef1a33&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cef1a33",
  null
  
)

export default component.exports